<template>
    <form id="fileForm" action="/target" class="dropzone">
        <h2 class="card-header text-center">
            File Upload </h2>
        <!-- Not displayed, just for Dropzone's `dictDefaultMessage` option -->
        <div id="dropzone-message" class="dz-message" >
            <span class="dropzone-title">File upload (accepted files are .pdf, .xlsx, and .xls):&nbsp; <button
                    type="button" aria-label="Please Select File">
                Please Select File </button></span>
            <span class="dropzone-info"><br/>Add multiple files by holding the ctrl button as selecting</span>
            <strong><br/>Document upload may take more than 30 seconds.</strong>
        </div>
        <div id="file" style="font-size: medium"></div>
        <div id="message" style="font-size: medium"></div>
        <div id="errorMessage" style="color: #a90000;font-size: medium"></div>
        <div id="invalidFile" style="color: #a90000;font-size: medium"></div>
        <div id="validDataFileMessageId" style="color: #4CAF50;font-size: medium"></div>
        <div id="validDataFileId" style="color: #4CAF50;font-size: medium"></div>
        <div id="notDataFileMessageId" style="color: #4CAF50;font-size: medium"></div>
        <div id="notDataFileId" style="color: #4CAF50;font-size: medium"></div>
        <div id="invalidDataFileMessageId" style="color: #a90000;font-size: medium"></div>
        <div id="invalidDataFileId" style="color: #a90000;font-size: medium"></div>
        <div id="unknownDataFileMessageId" style="color: #4CAF50;font-size: medium"></div>
        <div id="unknownDataFileId" style="color: #4CAF50;font-size: medium"></div>
    </form>

</template>

<script>
    import Dropzone from 'dropzone'
    import '../../node_modules/dropzone/dist/dropzone.css'
    import lambdaURL from '../lambda'
    import lambdaValidate from '../lambda3'
    import {eventBus} from "@/main";

    Dropzone.autoDiscover = false
    sessionStorage.clear();

    var vars = {
        //PROD
        bucketName: 'mdh-hepdataportal-ws-data'

        //NONPROD
        //bucketName: 'mdh-hepdataportal-nonprod-ws-data'
    }

    //filter the file size
    Dropzone.options.fileForm = {
        maxFilesize: 2, //2mb
        acceptedFiles: ".pdf,.xlsx,.xls",
        init: function () {

            this.on("error", function (file, message) {
                message = "Warning: " + file.name + " was removed due to file type and/or size. Accepted file types are .pdf, .xlsx, and .xls and each file must be 2MB or less.";
                alert(message);
                document.getElementById('invalidFile').innerHTML = "At least one file was removed due the file type and/or size.";
                this.removeFile(file);
            });
        }
    }


    export default {

        name: 'dropzone',
        props: {
            bucketName: {
                type: String,
                required: false
            }
        },

        mounted() {
            const vm = this
            let dateFormat = require("dateformat");

            let fileName = ''
            let options = {
                url: '/',
                method: 'put',
                timeout: 1200000,

                // Hijack the xhr.send since Dropzone always upload file by using formData
                // ref: https://github.com/danialfarid/ng-file-upload/issues/743
                sending(file, xhr) {
                    let _send = xhr.send
                    xhr.send = () => {
                        _send.call(xhr, file)
                    }
                },


                // Upload one file at a time since we're using the S3 pre-signed URL scenario
                parallelUploads: 1,
                uploadMultiple: false,
                header: '',
                /*dictDefaultMessage: document.querySelector('#dropzone-message').innerHTML,*/

                // We're going to process each file manually (see `accept` below)
                autoProcessQueue: false,

                // Here we request a signed upload URL when a file being accepted
                async accept(file, done) {
                    document.getElementById('message').innerHTML = 'Processing, please wait';
                    //clear all errors/messages on a each new uplaod
                    document.getElementById('file').innerHTML = '';
                    document.getElementById('errorMessage').innerHTML = '';
                    document.getElementById('invalidFile').innerHTML = '';
                    document.getElementById('validDataFileMessageId').innerHTML = '';
                    document.getElementById('validDataFileId').innerHTML = '';
                    document.getElementById('notDataFileMessageId').innerHTML = '';
                    document.getElementById('notDataFileId').innerHTML = '';
                    document.getElementById('invalidDataFileMessageId').innerHTML = '';
                    document.getElementById('invalidDataFileId').innerHTML = '';
                    document.getElementById('unknownDataFileMessageId').innerHTML = '';
                    document.getElementById('unknownDataFileId').innerHTML = '';

                    const fileExt = file.name.split('.').pop();
                    const datetime = dateFormat(new Date(), "mmddyy_HH:MM:") + Math.floor(Math.random() * 59);

                    let isValid = true;
                    lambdaValidate.readUploadFile(file).then((result) => {
                        console.log(">>>>> result: " + result.toString());

                        if (!'invalid'.includes(result[0]) && !'unknown'.includes(result[0]) && !'error'.includes(result[0])) {
                            fileName = result[0] + '_' + result[1] + '_' + datetime + '_' + result[2] + '.' + fileExt;
                            //Excel with Company information sheet and required fields
                            displayMessage(file, 'validDataFileKey', 'validDataFileMessageId',
                                'The following file(s) uploaded successfully', 'validDataFileId');
                        } else if ('unknown'.includes(result[0])) {
                            fileName = file.name;
                            //This was a PDF or an Excel file that likely didn't have a Company information sheet
                            displayMessage(file, 'notDataFileKey', 'notDataFileMessageId',
                                'The following file(s) uploaded successfully', 'notDataFileId');
                        } else if ('invalid'.includes(result[0])) {
                            //excel with Company information worksheet but there was missing required items
                            fileName = file.name;
                            isValid = false;
                            let errorIssues = "";
                            if ('1'.includes(result[1])) {
                                errorIssues += "</br>Invalid plan ID";
                            }
                            if ('2'.includes(result[2])) {
                                errorIssues += "</br>Invalid submission year (contact HCCIS staff)";
                            }
                            if ('3'.includes(result[3])) {
                                //errorIssues += "</br>Invalid total health care premium revenue";
                                errorIssues += "</br>Invalid financial level";
                            }

                            //console.log(">>>> INVALID DATA FILE: " + fileName);
                            displayMessage(file, 'invalidDataFileKey', 'invalidDataFileMessageId',
                                'The following file(s) NOT uploaded due to ' + errorIssues,
                                'invalidDataFileId');
                            this.removeFile(file);
                        } else if ('error'.includes(result[0])) {
                            // this was an excel file but it likely didn't even have a Company Information worksheet.
                            displayMessage(file, 'invalidDataFileKey', 'invalidDataFileMessageId',
                                'The following file(s) NOT uploaded due to invalid plan ID and/or invalid report year.',
                                'invalidDataFileId');
                            this.removeFile(file);
                        }


                        if (isValid) {
                            document.getElementById('message').innerHTML = 'Getting document(s) ready to save';
                            lambdaURL.execute(file, fileName, vars.bucketName).then((res) => {
                                file.uploadURL = res.url
                                console.log(file.uploadURL)
                                done()
                                setTimeout(() => vm.dropzone.processFile(file), 60)
                            })
                                .catch((err) => {
                                    done('Connection issue to file upload server', err);
                                    this.clearMessage();
                                    document.getElementById('errorMessage').innerHTML = 'We are having a connection issue.  Please try again later.<br>';
                                    document.getElementById('errorMessage').style.color = '#7a1904'; /* accessibility color contrast fix */
                                })
                        } else {
                            document.getElementById('message').innerHTML = 'Completed.  Please check the results below:<br>';
                        }
                    })
                        .catch((err) => {
                            done('Failed to get an S3 signed upload URL', err);
                            this.clearMessage();
                            //document.getElementById('errorMessage').innerText = 'Issue saving file(s):' + '<b>' + file.name + '</b>.  Please contact the system administrator for more information.<br>';
                            document.getElementById('errorMessage').innerText = 'Issue saving file(s):' + file.name.style('bold') + '.  Please contact the system administrator for more information.<br>';
                            document.getElementById('errorMessage').style.color = '#7a1904'; /* accessibility color contrast fix */
                        })
                },
                paramName: fileName
            }

            this.dropzone = new Dropzone(this.$el, options)

            // Set signed upload URL for each file
            vm.dropzone.on('processing', (file) => {
                vm.dropzone.options.url = file.uploadURL
            })

            vm.dropzone.on('complete', (file) => {
                //console.log("its done")
                //eventBus.$emit('upload-complete', this.bucketName)
                document.getElementById('message').innerHTML = 'Completed.  Please check the results below:<br>';
            })

            /**
             * This function loads the sessionStoreKey and display the message to the client
             * @param file
             * @param storageKey
             * @param messageId
             * @param message
             * @param messageFiles
             */
            function displayMessage(file, storageKey, messageId, message, messageFiles) {
                let dataFile = file.name;
                let dataFiles = '';

                if ('unknownDataFileKey' === storageKey) {
                    if (sessionStorage.unknownDataFileKey) {
                        dataFiles = sessionStorage.getItem(storageKey);
                    } else {
                        dataFiles = '';
                    }
                } else if ('notDataFileKey' === storageKey) {
                    if (sessionStorage.notDataFileKey) {
                        dataFiles = sessionStorage.getItem(storageKey);
                    } else {
                        dataFiles = '';
                    }
                } else if ('invalidDataFileKey' === storageKey) {
                    if (sessionStorage.invalidDataFileKey) {
                        dataFiles = sessionStorage.getItem(storageKey);
                    } else {
                        dataFiles = '';
                    }
                } else if ('validDataFileKey' === storageKey) {
                    if (sessionStorage.validDataFileKey) {
                        dataFiles = sessionStorage.getItem(storageKey);
                    } else {
                        dataFiles = '';
                    }
                }

                //dataFiles += '<b>' + dataFile + '</b>; ';
                dataFiles += dataFile + '; ';
                sessionStorage.setItem(storageKey, dataFiles);

                let storeData = sessionStorage.getItem(storageKey);
                document.getElementById(messageId).innerText = message + ':\n';
                document.getElementById(messageFiles).innerText = storeData.toString() + "\n";
                document.getElementById(messageFiles).style.fontWeight = 'bold';
            }

        } ,
        methods: {
            clearMessage: function () {
                document.getElementById('validDataFileMessageId').innerHTML = '';
                document.getElementById('validDataFileId').innerHTML = '';
                document.getElementById('invalidFile').innerHTML = '';
                document.getElementById('notDataFileMessageId').innerHTML = '';
                document.getElementById('notDataFileId').innerHTML = '';
                document.getElementById('invalidDataFileMessageId').innerHTML = '';
                document.getElementById('invalidDataFileId').innerHTML = '';
                document.getElementById('unknownDataFileMessageId').innerHTML = '';
                document.getElementById('unknownDataFileId').innerHTML = '';
            }
        }

    }


</script>

<style lang="stylus">
    primaryBlue = #3498db

    button:focus {
        border: 2px #0062cc;
    }

    .dropzone.dz-started .dz-message {
        display: block !important;
    }
    form.dropzone
        transition all 0.2s linear
        border 2px dashed #ccc
        background-color #ffffff
        min-height initial

        &:hover
            border-color primaryBlue
            background-color white

            .dz-message
                .dropzone-title
                    color primaryBlue

        .dz-message
            color #666
            align-self center

            span
                line-height 1.8
                font-size 13px
                letter-spacing 0.4px

                span.dropzone-title
                    display block
                    color #737373
                    font-size 1.25em

                span.dropzone-info
                    display block
                    color #737373

    .uploadButton {
        background-color: white;
        color: #737373;
        border: 2px solid #368730; /* Green */
        font-size: 1em;
    }

    .uploadButton:active {
        position: relative;
        top: 1px;
    }

    .uploadButton {
        transition-duration: 0.4s;
    }

    .uploadButton:hover {
        background-color: #368730; /* Green */
        color: white;
    }


</style>
